<template>
	<div v-show="false">
		<el-button type="primary" @click="openFullScreen1" v-loading.fullscreen.lock="fullscreenLoading">
			指令方式
		</el-button>

	</div>

</template>

<script>
	import {
		GetToken
	} from "../api/module/login"
	import Cookies from "js-cookie"
	export default {
		data() {
			return {
				urlInfo: '',
				fullscreenLoading: false
			}
		},
		methods: {
			openFullScreen1() {
				this.fullscreenLoading = true;
				setTimeout(() => {
					this.fullscreenLoading = false;
				}, 2000);
			},

			getUrlinfo() {
				let href = window.location.href
				let query = href.substring(href.indexOf('?') + 1);
				let vars = query.split("&");
				let obj = {}
				for (var i = 0; i < vars.length; i++) {
					let pair = vars[i].split("=");
					obj[pair[0]] = pair[1]
				}
				return obj;
			},
			upDataTokenAndInfo() {
				GetToken({},
					res => {
						console.log(res.obj)
						const loginInfo = {}
						const logerInfo = res.obj
						// 5-20   登录信息保存到缓存中
						Cookies.set("user", logerInfo)
						sessionStorage.setItem("loginUser", JSON.stringify(logerInfo)) // 关闭窗口后，登录信息不在
						// 将登陆信息保存到vuex
						this.$store.dispatch("recordLogInfo", logerInfo)
						// this.$router.push({ path: '/home' });
						this.$router.push({ path: "/homeStopOver" })
						Cookies.remove("hzfadminimagecode")
					},
					() => {


					}
				)
			}

		},
		mounted() {
			this.urlInfo = this.getUrlinfo()
			// this.urlInfo.sys = this.urlInfo.sys ? decodeURI(this.urlInfo.sys) : ''
			console.log(this.urlInfo)
			if (this.urlInfo.token) {
				let arr = this.urlInfo.token.split('%3A').join(':')
				Cookies.set("HEARDTOKENID", arr)
				Cookies.set("defaultSystem", this.urlInfo.defaultSystem)
				Cookies.set("systemId", this.urlInfo.systemId)
				this.upDataTokenAndInfo()
			}
			this.fullscreenLoading = true
			// FE-0.0-0.0-2020-08-07T14%3A13%3A00.476
			// FE-0.0-0.0-2020-08-07T14:13:00.476
		}
	}
</script>
